import React from 'react';
import { useHistory } from 'react-router';
import { IoCloseSharp } from 'react-icons/io5';
import { MdRadioButtonChecked, MdRadioButtonUnchecked, MdHelpOutline } from 'react-icons/md';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/bill-success.svg';


interface Props extends PropsFromRedux {}

const DeliveryType: React.FC<Props> = ({ hideModal, showModal }) => {
  
  const history = useHistory();

  const closeModal = () => {
    hideModal();
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
        <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
            <button type="button" aria-label="Close" onClick={closeModal}>
                <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
            </button>
         
            <div className="w-full my-4 text-left">
                <h2 className="mb-1 text-sm font-semibold text-left text-gray-400">Delivery type</h2>
            </div>
            <div className="w-56">
                <h2 className="my-1 text-gray-800 text-md font-bold">Go Standard</h2>
                <p className="text-xs my-2 text-gray-500 font-medium">Satisfactory service delivery. Get your items 
                 delivered to your destination within 
                 15 business days</p>
            </div>
            <div className="w-56">
                <h2 className="my-1 text-gray-800 text-md font-bold">Go Faster</h2>
                <p className="text-xs my-2 text-gray-500 font-medium">Fast service delivery. Get your items 
                delivered to your destination
                within 7 business days.</p>
            </div>
        </div>
  );
  // </ModalWrapper>
};

export default DeliveryType;